import { render } from "./ProcessingDataForm.vue?vue&type=template&id=31b90f52&scoped=true&ts=true"
import script from "./ProcessingDataForm.vue?vue&type=script&lang=ts"
export * from "./ProcessingDataForm.vue?vue&type=script&lang=ts"

import "./ProcessingDataForm.vue?vue&type=style&index=0&id=31b90f52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b90f52"]])

export default __exports__